import React from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import AuthService from '../services/AuthService';
import universityLogo from '../assets/logo-new.png';

export default function Header() {
  const location = useLocation();
  const showLogout = AuthService.isTokenValid() && !['/login', '/logout'].includes(location.pathname);
  return (
    <header>
      <Navbar aria-label="Site" bg="white" expand="lg" className="shadow-sm mb-3">
        <Container className="application-header-content">
          <Navbar.Brand as={Link} to="/" className="application-brand">
            <img src={universityLogo} alt="Minnesota State University Mankato" width="200" className="header-logo" />
          </Navbar.Brand>
          <div className="application-header-actions">
            <div className="navbar-title">Graduation Application</div>
            {showLogout && <Link to="/logout" className="text-decoration-none fw-semibold" style={{ color: '#4F2A82' }}>Logout</Link>}
          </div>
        </Container>
      </Navbar>
    </header>
  );
}
